import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { CommissionCalculator } from '../commission-calculator/commission-calculator';
import { MatIconModule } from '@angular/material/icon';
import { GtmService } from '../../../../core/services/gtm.service';
import { SeoService } from '../../../../shared/services/seo.service';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sales-home',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule
  ],
  standalone: true,
  templateUrl: './sales-home.html',
  styleUrl: './sales-home.scss',
})
export class SalesHome implements OnInit {
  private dialog = inject(MatDialog);
  private router = inject(Router);

  private gtm = inject(GtmService);
  private seo = inject(SeoService);
  platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.body.scrollTop = 0;
      this.gtm.pageView({
        page_path: '/sales',
        page_title: 'Become a Sales Agent | Horizinns'
      });
    }
    this.seo.updateMetaTags(
      'Become a Sales Agent', 
      'Learn the process and benefits of becoming a sales agent with Horizinns', 
      undefined, 
      `${environment.appUrl}/sales`);

    this.seo.addJsonLd({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Become a Sales Agent",
      "description": "Learn the process and benefits of becoming a sales agent with Horizinns",
      "url": "${environment.appUrl}/sales"
    });
  }

  openCalculator = () => {
    const dialogRef = this.dialog.open(CommissionCalculator, {
      panelClass: ['commission-dialog'],
      width: '460px'
    });

    dialogRef.componentInstance.cancel.subscribe(() => {
      console.log('Cancelled');
      dialogRef.close();
    });
  }

  goToContact() {
    this.router.navigate(['contact', 'sales']);
  }

  goToCreateAccount() {
    this.router.navigate(['signup']);
  }

  goToSalesTerms() {
    this.router.navigate(['common-forms']);
  }
}
